import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useProfile } from '../../providers/Profile';
import './SpecialDayOffApiFailure.scss';

function SpecialDayOffApiFailure() {
    const { t } = useTranslation();
    const profileContext = useProfile();
    const profileData = profileContext?.profile?.results;   
    const[hrefData,setHrefData] = useState("");
    
    useEffect(()=>{
        setHrefData(`mailto:myaccess@aircanada.ca?&subject=SDO - Submission failed &body=Hello Team,%20%0D%0AName is ${profileData?.['name']} Emp id is ${profileData?.EmployeeId}, Base Location is ${profileData?.baseLocation} and Equipment is ${profileData?.equipment}`);
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    
    return (
        <div className='sdoApiFailure__container' id="sdoApiFailure__container__id">
            <i className='icon-Error-warning' />
            <div className='sdoApiFailure__info-text'>
                <p> {t('specialDayOff.specialDayOffHeader.apiFalure')}</p>
                <p title="myaccess@aircanada.ca"> {t('specialDayOff.specialDayOffHeader.apiFalureText')} <span className='sdoApiFailure__additional-info-ref'><a className='sdoApiFailure__additional-info-ref' href={hrefData}>{t('specialDayOff.specialDayOffHeader.apiFalureTextLink')}</a></span></p>
            </div>
        </div>
    );
}

export default SpecialDayOffApiFailure;
